import styled from 'styled-components';
const getVariantColours = ({ variant = 'tan', theme } = {}) => {
  const variants = {
    tan: {
      background: theme.colours.tan,
      text: theme.colours.red,
    },
    yellow: {
      background: theme.colours.yellow,
      text: theme.colours.red,
    },
    brown: {
      background: theme.colours.brown,
      text: theme.colours.yellow,
    },
    blue: {
      background: theme.colours.blue,
      text: theme.colours.yellow,
    },
    darkbrown: {
      background: '#592A03',
      text: theme.colours.yellow,
    },
  };

  if (variant in variants) return variants[variant];

  return variants.tan;
};
const SmallImageWithTextWrapper = styled.section`
  background-color: ${({ backgroundColor, backgroundHex, theme }) =>
    backgroundHex
      ? backgroundHex // use raw hex if provided
      : getVariantColours({ theme, variant: backgroundColor }).background};
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 5rem;
  width: 1320px;
  max-width: 90%;
  margin: auto;
  @media (max-width: 1100px) {
    gap: 2rem;
  }
  @media (max-width: 900px) {
    gap: 0;
  }
`;



export const ImageCol = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 3;
  justify-content: center;
  align-items: center;
  img{
    max-width: 100%;
    height: auto;
  }
  @media (max-width: 900px) {
      grid-column: span 12;
  }
`;

export const ContentCol = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 9;
  justify-content: center;
  @media (max-width: 900px) {
    grid-column: span 12;
  }
`;

export const StyledHeading = styled.div`
  color: ${({ theme, headingColor }) =>
    theme.colours.checkColourExists(headingColor) || headingColor || theme.colours.text};
  margin-bottom: ${({ theme }) => theme.spacing(20)};
  font-size: 2rem;
  font-weight: bold;
  h2{
    text-align: left;
    font-size: clamp(35px, 5vw, 56px);
    text-transform: uppercase;
    font-family: "apercu condensed pro", impact;
    position: relative;
    margin: 0;
    line-height: 1.2;
    color: ${({ theme, headingColor }) =>
      theme.colours.checkColourExists(headingColor) || headingColor || theme.colours.text};
  }
`;

export const StyledText = styled.div`
  color: ${({ theme, textColor }) =>
    theme.colours.checkColourExists(textColor) || textColor || theme.colours.text};
  p{
    font-size: clamp(18px, 5vw, 22px);
    font-family: "apercu pro", apercu pro, sans-serif;
    font-weight: 300;
    line-height: 1.3;
    color: ${({ theme }) => theme.colours.tan};
    margin-bottom: 0;
  }
  @media (max-width: 700px) {
    p{
      font-size: 18px;
    }
  }
`;

export default SmallImageWithTextWrapper;